import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errorText(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Revisa los datos: el correo debe ser válido y la contraseña de al menos 8 caracteres.";
  return "No pudimos conectar en este momento. Intenta de nuevo en un rato.";
}
